import React, { forwardRef } from 'react';
import './CustomInput.css';
import { CustomInputType } from './types/CustomInputType';

/**
 * CustomInput Component
 * A robust input component with support for labels, icons, errors, and theme integration.
 */
export const CustomInput = forwardRef<HTMLInputElement, CustomInputType>(({
    label,
    name,
    value,
    defaultValue,
    placeholder,
    type = 'text',
    error,
    helperText,
    disabled = false,
    required = false,
    readOnly = false,
    autoFocus = false,
    leftIcon,
    rightIcon,
    className = '',
    onChange,
    onBlur,
    onFocus,
    onKeyDown,
    autoComplete,
    max,
    min,
}, ref) => {
    return (
        <div className={`custom-input-wrapper ${className}`}>
            {label && (
                <label htmlFor={name} className="custom-input__label">
                    {label} {required && <span style={{ color: '#ef4444' }}>*</span>}
                </label>
            )}
            
            <div className="custom-input__field-container">
                {leftIcon && <div className="custom-input__icon custom-input__icon--left">{leftIcon}</div>}
                
                <input
                    ref={ref}
                    id={name}
                    name={name}
                    type={type}
                    value={value}
                    defaultValue={defaultValue}
                    placeholder={placeholder}
                    disabled={disabled}
                    readOnly={readOnly}
                    autoFocus={autoFocus}
                    onChange={onChange}
                    onBlur={onBlur}
                    onFocus={onFocus}
                    onKeyDown={onKeyDown}
                    autoComplete={autoComplete}
                    max={max}
                    min={min}
                    className={`
                        custom-input__field 
                        ${error ? 'custom-input__field--has-error' : ''} 
                        ${leftIcon ? 'custom-input__field--has-left-icon' : ''} 
                        ${rightIcon ? 'custom-input__field--has-right-icon' : ''}
                    `}
                />

                {rightIcon && <div className="custom-input__icon custom-input__icon--right">{rightIcon}</div>}
            </div>

            {error && <p className="custom-input__error-text">{error}</p>}
            {helperText && !error && <p className="custom-input__helper-text">{helperText}</p>}
        </div>
    );
});

export default CustomInput;
